import Team from '@/app/staticPages/team'

export default Team
